import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './key-highlights.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class KeyHighlights extends s {
    constructor() {
        super(...arguments);
        this.title = '';
        this.isRtl = false;
        this.containerClassNames = '';
    }
    render() {
        this.containerClassNames = getStyleClassNames({
            isRtl: this.isRtl,
        });
        return x `<div class="key-highlights ${this.containerClassNames}"><div class="title-container"><slot name="title">${this.title}</slot></div><div class="items-container"><slot></slot></div></div>`;
    }
}
KeyHighlights.styles = css_248z;
__decorate([
    n({ type: String })
], KeyHighlights.prototype, "title", void 0);
__decorate([
    n({ type: Boolean })
], KeyHighlights.prototype, "isRtl", void 0);
customElements.define('key-highlights', KeyHighlights);

export { KeyHighlights };
